module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._m(0), _vm._v(" "), _c('custom-table', {
    attrs: {
      "edit": "",
      "add": "",
      "delete": "",
      "src-model": _vm.$store.getters.models('denominations'),
      "cols": _vm.model.cols,
      "store": "denominations",
      "search": "",
      "default-sort": _vm.defSort
    },
    on: {
      "edit": _vm.editCat,
      "add": _vm.newCat,
      "delete": _vm.removeCat
    }
  })], 1), _vm._v(" "), (_vm.showModal) ? _c('custom-modal', {
    attrs: {
      "title": _vm.modalTitle,
      "ok-text": "Speichern",
      "cancel-text": "Abbrechen",
      "cancel-style": "btn btn-default"
    },
    on: {
      "cancel": function($event) {
        _vm.showModal = false
      },
      "ok": _vm.quitModal
    }
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.name),
      expression: "model.model.name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name",
      "id": "name",
      "required": "required"
    },
    domProps: {
      "value": (_vm.model.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.name = $event.target.value
      }
    }
  })])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Konfessionen")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5ae02eec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Denomations.vue
// module id = 446
// module chunks = 0